export const FETCH_USER_ADMIN = 'fetch_user_admin'
export const FETCH_USER_RESELLER = 'fetch_user_reseller'
export const LOGIN_ADMIN = 'login_admin'
export const LOGIN_RESELLER = 'login_reseller'
export const TWOFA = 'two_factor_authentication'
export const LOGOUT = 'logout'
export const FETCH_GAMES = 'fetch_games'
export const FETCH_ORDERS = 'fetch_orders'
export const FETCH_RESELLERS = 'fetch_resellers'
export const FETCH_ADMINS = 'fetch_admins'
export const FETCH_SETTINGS = 'fetch_settings'